import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { ApolloClient } from '@apollo/client';
import { Link } from 'react-router-dom';
import { Button } from '@teamsnap/teamsnap-ui';
import { AuthContext } from 'auth/dist/contexts';
import './programs.scss';
import { hasPermissionForOrg, Permission } from 'core/permissions';
import ProgramGuide from '../../components/program/program-guide/program-guide';
import * as GqlPrograms from '../../core/gql/queries/programs';
import * as HistoricalSeasons from '../../core/gql/queries/historical-seasons';
import { useQuery } from '@apollo/client';
import ProgramList from 'components/program/program-list';

interface Props extends RouteComponentProps<any> {
  client: ApolloClient<any>;
}

const Programs = ({
  match: {
    params: { orgId },
  },
}: Props) => {
  const context = React.useContext(AuthContext);
  const canUserCreateProgram = hasPermissionForOrg(context.user, Permission.OrgUpdate, orgId);
  const canUserViewOrg = hasPermissionForOrg(context.user, Permission.OrgView, orgId);
  const [isGuideOpen, setIsGuideOpen] = React.useState(false);
  const queryPrograms = useQuery(GqlPrograms.QUERY, { variables: { organizationId: +orgId } });
  const programs = queryPrograms.data?.programs || [];
  const queryHistoricalSeasons = useQuery(HistoricalSeasons.QUERY, { variables: { organizationId: +orgId } });
  const historicalSeasons = queryHistoricalSeasons.data?.historicalSeasons || [];

  const hasOrgPrograms = queryPrograms.data?.programs?.length > 0;
  const isLoading = queryPrograms.loading || queryHistoricalSeasons.loading;
  const hasError = !!(queryPrograms.error || queryHistoricalSeasons.error);

  return (
    <>
      <div id="programs" className="container hub-full-width">
        <div className="page-content u-xs-padXl u-flexExpandSides">
          <div className="page-content-header Grid u-flexAlignItemsCenter">
            <div className="Grid-cell u-xs-size1of2">
              <h1>Programs</h1>
            </div>
            {hasOrgPrograms ? (
              <div className="Grid-cell u-xs-size1of2 u-textRight button-list">
                {canUserCreateProgram && (
                  <Button
                    data-testid="program-guide-start-button"
                    color="primary"
                    icon="plus"
                    onClick={() => setIsGuideOpen(!isGuideOpen)}
                  >
                    Guide My Setup
                  </Button>
                )}
                {canUserViewOrg && (
                  <Link to={`/organizations/${orgId}/programs-report`}>
                    <Button>Show Programs Report</Button>
                  </Link>
                )}
              </div>
            ) : null}
          </div>
          <div className="page-content-body">
            <ProgramList
               orgId={orgId}
               programs={programs}
               historicalSeasons={historicalSeasons}
               isLoading={isLoading}
               hasError={hasError}
               isGuideOpen={isGuideOpen}
               setIsGuideOpen={setIsGuideOpen}
            />
          </div>
        </div>
      </div>
      <ProgramGuide
        orgId={+orgId}
        isOpen={isGuideOpen}
        setOpen={setIsGuideOpen}
        whenProgramCreated={queryPrograms.refetch}
      />
    </>
  );
};

export default Programs;
